module.exports = __webpack_public_path__ + "img/ust_entrepreneurship_center.44c9d9e0.png";